import { AbstractRepository } from '@/repositories/abstract-repository';
import { Timezone } from '@/core/timezones/timezone';

export class TimezonesRepository extends AbstractRepository<Timezone> {
    readonly endpoint = 'types/timezones';
}
